import React, { useState, useEffect, useCallback, useRef } from "react";
import Sidebar from "../Sidebar/Sidebar";
import NotificationBell from "./NotificationBell";
import NotificationsPage from "./NotificationsPage";
import "./AdminDashboard.css";
import {
  fetchDashboardData, 
  fetchFlightStats,
  fetchRecentMissions,
  fetchDashboardSummary, 
  fetchTopPilotsByHours,
  fetchNotifications,
} from "../Apis/AdminApis";
import { useNavigate,useLocation } from "react-router-dom";
import pavamanLogo from "../images/drone.png"; 
import {
  GoogleMap,
  Marker,
  Polyline,
  MarkerClusterer,
  useJsApiLoader,
  Circle
} from "@react-google-maps/api";
import { FiPlayCircle, FiBarChart2,FiChevronUp,FiChevronDown } from "react-icons/fi";
import useDashboardWebSocket from "../../src/hooks/useDashboardWebSocket";
import PopupMessage from "../PopupMessage/PopupMessage";
import API_BASE_URL from "../config";
import { useDashboardCache } from "../../src/hooks/useDashboardCache";


const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const mapContainerStyle = {
  height: "350px",
  width: "100%",
  borderRadius: "16px"
};

const defaultCenter = {
  lat: 20.5937,
  lng: 78.9629
};

const mapOptions = {
  mapTypeId: "hybrid",
  gestureHandling: "greedy",
  disableDefaultUI: false,
  tilt: 0,
  zoomControl: true,
  mapTypeControl: true,
  scaleControl: true,
  streetViewControl: true,
  rotateControl: true,
  fullscreenControl: true,
};


const createDroneIcon = (
  color,
  isSelected = false,
  heading = 0
) => {

  const mainColor = color;

  const glowColor = isSelected
    ? color
    : `${color}EE`;

  const svg = `
  <svg xmlns="http://www.w3.org/2000/svg"
       width="80"
       height="80"
       viewBox="0 0 80 80">

    <defs>

      <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur stdDeviation="4" result="blur"/>
        <feMerge>
          <feMergeNode in="blur"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>

    </defs>

    <g
      transform="rotate(${heading || 0} 40 40)"
      filter="url(#glow)"
      stroke-linecap="round"
      stroke-linejoin="round"
    >

      <line x1="28" y1="28" x2="16" y2="16"
        stroke="black" stroke-width="8" />

      <line x1="52" y1="28" x2="64" y2="16"
        stroke="black" stroke-width="8" />

      <line x1="28" y1="52" x2="16" y2="64"
        stroke="black" stroke-width="8" />

      <line x1="52" y1="52" x2="64" y2="64"
        stroke="black" stroke-width="8" />

      <line x1="28" y1="28" x2="16" y2="16"
        stroke="${glowColor}" stroke-width="4" />

      <line x1="52" y1="28" x2="64" y2="16"
        stroke="${glowColor}" stroke-width="4" />

      <line x1="28" y1="52" x2="16" y2="64"
        stroke="${glowColor}" stroke-width="4" />

      <line x1="52" y1="52" x2="64" y2="64"
        stroke="${glowColor}" stroke-width="4" />

    <circle cx="14" cy="14" r="9" fill="black" />
<circle cx="66" cy="14" r="9" fill="black" />
<circle cx="14" cy="66" r="9" fill="black" />
<circle cx="66" cy="66" r="9" fill="black" />

      <circle cx="14" cy="14" r="6" fill="${mainColor}" />
      <circle cx="66" cy="14" r="6" fill="${mainColor}" />
      <circle cx="14" cy="66" r="6" fill="${mainColor}" />
      <circle cx="66" cy="66" r="6" fill="${mainColor}" />

      <circle cx="40" cy="40" r="12" fill="black" />

      <circle cx="40" cy="40" r="8"
        fill="${mainColor}" />

    </g>
  </svg>
  `;

  return {
    url:
      "data:image/svg+xml;charset=UTF-8," +
      encodeURIComponent(svg),

    scaledSize: new window.google.maps.Size(
      isSelected ? 52 : 40,
      isSelected ? 52 : 40
    ),

    anchor: new window.google.maps.Point(
      isSelected ? 26 : 20,
      isSelected ? 26 : 20
    ),
  };
};

const FlyToDrone = ({
  drone,
  map,
  droneTrails,
  selectedDroneTelemetry
}) => {

  useEffect(() => {

    if (drone && map) {

      const trail =
        droneTrails[
          `${drone.vehicle_id}_${drone.mission_id}`
        ];

      if (trail && trail.length > 1) {

        const bounds =
          new window.google.maps.LatLngBounds();

        trail.forEach(point => {
          bounds.extend({
            lat: point.lat,
            lng: point.lng
          });
        });

        bounds.extend({
          lat: Number(drone.lat),
          lng: Number(drone.lng)
        });

        map.fitBounds(bounds);

      } else {

        map.panTo({
          lat: Number(drone.lat),
          lng: Number(drone.lng)
        });

        map.setZoom(19);
      }
    }

  }, [drone]);

  useEffect(() => {

    if (
      !selectedDroneTelemetry ||
      !map
    ) return;

    map.panTo({
      lat: Number(selectedDroneTelemetry.lat),
      lng: Number(selectedDroneTelemetry.lng)
    });

  }, [selectedDroneTelemetry]);



  return null;
};

const FitBounds = ({ positions, selectedDrone, droneTrails, map }) => {
  useEffect(() => {
    if (!positions || positions.length === 0 || selectedDrone || !map) return;

    const bounds = new window.google.maps.LatLngBounds();
    
    positions.forEach(drone => {
      bounds.extend({ lat: Number(drone.lat), lng: Number(drone.lng) });
      
      const trail = droneTrails[`${drone.vehicle_id}_${drone.mission_id}`];
      if (trail && trail.length > 0) {
        trail.forEach(point => {
          bounds.extend({ lat: point.lat, lng: point.lng });
        });
      }
    });

   if (
  positions.length > 0 &&
  map.getZoom() < 10
) {
  map.fitBounds(bounds);
}

  }, [positions, selectedDrone, map, droneTrails]);

  return null;
};

const DroneTrails = ({ droneTrails, selectedDrone }) => {
  const keys = Object.keys(droneTrails);

  if (!keys.length) return null;

  return (
    <>
      {keys.map((key) => {
        const positions = droneTrails[key];
        if (!positions || positions.length < 2) return null;

        const trailPoints = positions.map(p => ({
          lat: p.lat,
          lng: p.lng
        }));

        const isSelected =
          selectedDrone &&
          key === `${selectedDrone.vehicle_id}_${selectedDrone.mission_id}`;

        return (
          <Polyline
            key={key}
            path={trailPoints}
           options={{
  strokeColor: isSelected ? "#00E5FF" : "#00FF85",
  strokeOpacity: isSelected ? 1 : 0.95,
  strokeWeight: isSelected ? 5 : 4,
  geodesic: true,
  zIndex: isSelected ? 999 : 10,
  icons: [
    {
      icon: {
        path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        scale: isSelected ? 3 : 2.5,
        strokeColor: isSelected ? "#00E5FF" : "#00FF85",
        strokeWeight: 2,
      },
      offset: "100%",
      repeat: "60px",
    },
  ],
}}
          />
        );
      })}
    </>
  );
};

const DroneMarker = React.memo(
  ({
    drone,
    clusterer,
    icon,
    onClick,
    isSelected
  }) => {

    const position = {
      lat: Number(drone.lat),
      lng: Number(drone.lng)
    };

    return (
      <>
        <Marker
          position={position}
          clusterer={clusterer}
          icon={icon}
          onClick={onClick}
          optimized={true}
          zIndex={isSelected ? 9999 : 1}
          opacity={isSelected ? 1 : 0.9}
        />

        {isSelected && (
          <Circle
            center={position}
            radius={12}
            options={{
              strokeColor: "#00FFFF",
              strokeOpacity: 0.9,
              strokeWeight: 2,
              fillColor: "#00FFFF",
              fillOpacity: 0.15,
              zIndex: 9998
            }}
          />
        )}
      </>
    );
  }
);

const TelemetryDisplay = ({ drone }) => {
  if (!drone) return null;

  const maxVoltage = 16.8;
  const minVoltage = 12.0;
  const currentVoltage = drone.voltage || 12.6;
  
  return (
    <div className="dash-telemetry-panel">
      <div className="dash-telemetry-header">
        <span className="dash-telemetry-id">{drone.vehicle_id}</span>
        <span className="dash-telemetry-badge dash-status-live">
          {drone.status || "LIVE"}
        </span>
      </div>

     <div className="dash-telemetry-grid">

  <div className="telemetry-card">
    <span className="telemetry-title">Pilot</span>
    <span className="telemetry-data email">
      {drone.pilot_email || "N/A"}
    </span>
  </div>

  <div className="telemetry-card">
    <span className="telemetry-title">Mission</span>
    <span className="telemetry-data">
      {drone.mission_id || "N/A"}
    </span>
  </div>

  <div className="telemetry-card">
    <span className="telemetry-title">Altitude</span>
    <span className="telemetry-data">
      {drone.alt ? Number(drone.alt).toFixed(1) : "0.0"} m
    </span>
  </div>

  <div className="telemetry-card">
    <span className="telemetry-title">Speed</span>
    <span className="telemetry-data">
      {drone.speed ? Number(drone.speed).toFixed(1) : "0.0"} m/s
    </span>
  </div>
   <div className="telemetry-card">
    <span className="telemetry-title">Voltage</span>
    <span className="telemetry-data">
      {drone.voltage ? Number(drone.voltage).toFixed(1) : "0.0"} v
    </span>
  </div>
  <div className="telemetry-card">
          <span className="telemetry-title">Satellites:</span>
          <span className="telemetry-data">
            {drone.satellites || "0"}
          </span>
        </div>

        <div className="telemetry-card">
          <span className="telemetry-title">HDOP:</span>
          <span className="telemetry-data">
            {drone.hdop ? Number(drone.hdop).toFixed(2) : "0.00"}
          </span>
        </div>
 <div className="telemetry-card">
  <span className="telemetry-title">Updated:</span>

  <span className="telemetry-data">
    {drone?.ts !== undefined &&
    drone?.ts !== null
      ? new Date(Number(drone.ts)).toLocaleTimeString(
          "en-IN",
          {
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          }
        )
      : "N/A"}
  </span>
</div>

</div>
    </div>
  );
};

const calculatePilotStatsFromMissions = (missions) => {
  const vehiclesMap = new Map();
  let totalMissions = 0;
  let totalSprayedAcres = 0;
  let totalLitres = 0;
  let totalFlightMinutes = 0;
  
  missions.forEach(mission => {
    totalMissions++;
    const summary = mission.summary || {};
    
if (summary.flying_time_minutes !== undefined && summary.flying_time_minutes !== null) {
  totalFlightMinutes += parseFloat(summary.flying_time_minutes);
}
    if (summary.total_sprayed_acres) {
      totalSprayedAcres += parseFloat(summary.total_sprayed_acres);
    }
    
    if (summary.total_liters) {
      totalLitres += parseFloat(summary.total_liters);
    }
    
    if (mission.vehicle_id) {
      if (!vehiclesMap.has(mission.vehicle_id)) {
        vehiclesMap.set(mission.vehicle_id, {
          vehicle_id: mission.vehicle_id,
          uin: mission.vehicle_uin || "N/A",
          mission_count: 0,
          sprayed_acres: 0,
          litres: 0
        });
      }
      
      const vehicle = vehiclesMap.get(mission.vehicle_id);
      vehicle.mission_count++;
      if (summary.total_sprayed_acres) vehicle.sprayed_acres += parseFloat(summary.total_sprayed_acres);
      if (summary.total_liters) vehicle.litres += parseFloat(summary.total_liters);
    }
  });
  
  return {
    total_missions: totalMissions,
    total_sprayed_acres: totalSprayedAcres.toFixed(2),
    total_litres: totalLitres.toFixed(2),
    total_flight_minutes: totalFlightMinutes.toFixed(2),
    vehicles: Array.from(vehiclesMap.values())
  };
};

const Dashboard = () => {
  const location = useLocation();
  useEffect(() => {
  if (location.state?.dashboardFilters) {
    const filters = location.state.dashboardFilters;

    setTimeRange(filters.timeRange);
    setCustomDateRange({
      start_date: filters.startDate || "",
      end_date: filters.endDate || "",
    });
    setPilotSearch(filters.pilotSearch || "");
    setSelectedMinutes(filters.selectedMinutes || "");
    setTimeFilterType(filters.timeFilterType || "");

    setAppliedPilotSearch(filters.pilotSearch || "");
    setAppliedMinutes(filters.selectedMinutes || "");
    setAppliedTimeFilterType(filters.timeFilterType || "");

  }
}, [location.state]);
  const [activeTab, setActiveTab] = useState('overview');
  const [timeRange, setTimeRange] = useState(() => {
    return localStorage.getItem("adminDashboardTimeRange") || "week";
  });

  const [customDateRange, setCustomDateRange] = useState(() => {
    const savedRange = localStorage.getItem("adminDashboardCustomDateRange");
    return savedRange
      ? JSON.parse(savedRange)
      : { start_date: "", end_date: "" };
  });

  const [showDatePicker, setShowDatePicker] = useState(false);
  // ── isLoading and error are now provided by useDashboardCache (see below)
  //    we keep the declaration here as placeholders that get overwritten
  const [error, setError] = useState(null);
  const navigate = useNavigate();
const [selectedMinutes, setSelectedMinutes] = useState("");
const selectedMinutesRef = useRef("");
  const [isLoadingMissions, setIsLoadingMissions] = useState(false);
  const [missionsError, setMissionsError] = useState(null); 
  const [expandedMissionStats, setExpandedMissionStats] = useState(null);
  const [statsPopupAnchor, setStatsPopupAnchor] = useState(null);
  const [vehicleHours, setVehicleHours] = useState([]);
  const [isVehicleHoursLoading, setIsVehicleHoursLoading] = useState(false);
  const [topPilots, setTopPilots] = useState([]);
  const [isTopPilotsLoading, setIsTopPilotsLoading] = useState(false);

  // ── firstLoad and isFetchingRef are no longer needed — removed ──────────
  // (the hook manages both internally)

  const [viewAsAdminId, setViewAsAdminId] = useState(
    sessionStorage.getItem("view_as_admin_id") ||
    localStorage.getItem("view_as_admin_id") ||
    null
  );

  useEffect(() => {
    localStorage.setItem("adminDashboardTimeRange", timeRange);
  }, [timeRange]);

  useEffect(() => {
    localStorage.setItem(
      "adminDashboardCustomDateRange",
      JSON.stringify(customDateRange)
    );
  }, [customDateRange]);

  const [adminId, setAdminId] = useState(null);
  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey,
  });

  const [pilotSearch, setPilotSearch] = useState("");
  const pilotSearchRef = useRef("");
  const [selectedPilotMission, setSelectedPilotMission] = useState(null);
const [timeFilterType, setTimeFilterType] = useState("");
const timeFilterTypeRef = useRef("");
  const [pilotStatsPopup, setPilotStatsPopup] = useState(false);
  const [pilotTimeStats, setPilotTimeStats] = useState({
    total_missions: 0,
    total_sprayed_acres: 0,
    total_flight_minutes: 0,
    total_litres: 0,
    vehicles: [],
  });

  const [isPilotStatsLoading, setIsPilotStatsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    missions: { vehicles: [] },
    battery: { vehicles: [] },
    positions: { vehicles: [] },
    flightStatus: { vehicles: [] },
    sprayData: { vehicles: [] },
  });
  
  const [stats, setStats] = useState({
    totalFlights: 0,
    totalAcres: 0,
    activeDrones: 0,
    activePilots: 0,
    flightHours: 0,
    sprayedAcres: 0,
  });

const [notificationsData, setNotificationsData] = useState({
  unread_count: 0,
  notifications: [],
});
  const [recentFlights, setRecentFlights] = useState([]);
  const [pilotActivity, setPilotActivity] = useState([]);
  const [sprayCoverage, setSprayCoverage] = useState([]);
  const [weeklyData, setWeeklyData] = useState([]);
  const [livePositions, setLivePositions] = useState([]);
  const [droneTrails, setDroneTrails] = useState({});
  const [currentWeekStart, setCurrentWeekStart] = useState('');
  const [currentWeekEnd, setCurrentWeekEnd] = useState('');
  const [isWeeklyDataLoading, setIsWeeklyDataLoading] = useState(false);
  const [totalFlightsThisWeek, setTotalFlightsThisWeek] = useState(0);
  const [totalAcresThisWeek, setTotalAcresThisWeek] = useState(0);
  const [allMissions, setAllMissions] = useState([]);
  const [isAllMissionsLoading, setIsAllMissionsLoading] = useState(false);
  const [selectedDrone, setSelectedDrone] = useState(null);
  const [selectedDroneTelemetry, setSelectedDroneTelemetry] = useState(null);
const [filtersRestored, setFiltersRestored] = useState(false);
  useEffect(() => {
    if (!selectedDrone) return;
    const updatedDrone = livePositions.find(
      d =>
        d.vehicle_id === selectedDrone.vehicle_id &&
        d.mission_id === selectedDrone.mission_id
    );
    if (updatedDrone) {
      setSelectedDroneTelemetry(updatedDrone);
    }
  }, [livePositions, selectedDrone]);

  const mapRef = useRef(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [additionalStats, setAdditionalStats] = useState({
    totalPilotsWithMissions: 0,
    totalSprayedAcres: 0,
    totalSprayLiters: 0,
    totalSprayMissions: 0
  });

  const droneColors = [
    "#00FFFF",
    "#39FF14",
    "#FF3131",
    "#FFD700",
    "#FF00FF",
    "#00BFFF",
  ];

  useEffect(() => {
  }, []);
useEffect(() => {
  const loadNotificationCount = async () => {
    try {
      const response = await fetchNotifications("count");

      if (response?.error) {
        console.error("Notifications error:", response.error);
        setNotificationsData((prev) => ({ ...prev, unread_count: 0 }));
        return;
      }

      setNotificationsData((prev) => ({
        ...prev,
        unread_count: Number(response?.unread_count || 0),
      }));
    } catch (error) {
      console.error("❌ Failed to load notification count:", error);
      setNotificationsData((prev) => ({ ...prev, unread_count: 0 }));
    }
  };

  loadNotificationCount();
}, [viewAsAdminId]);

  const handleReplayMission = (mission) => {
    navigate("/admin/mission-replay", {
      state: {
  missionId: mission.mission_id,
  droneId: mission.vehicle_id,
  pilotId: mission.pilot_id,
  missionData: mission,
  from: "dashboard", 
    // Preserve dashboard filters
dashboardFilters: {
  timeRange,
  startDate: customDateRange.start_date,
  endDate: customDateRange.end_date,

  pilotSearch: appliedPilotSearch,
  selectedMinutes: appliedMinutes,
  timeFilterType: appliedTimeFilterType
}
}
    });
  };

  const getCurrentWeekMonday = () => {
    const today = new Date();
    const day = today.getDay();
    const diff = today.getDate() - day + (day === 0 ? -6 : 1);
    const monday = new Date(today.setDate(diff));
    return monday.toISOString().split('T')[0];
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString.replace(" ", "T"));
    if (isNaN(date)) return dateString;
    return date.toLocaleString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  };

  const processDronePerformance = useCallback((data) => {
    const performance = [];
    data.battery.vehicles.forEach(batteryVehicle => {
      const vehicleId = batteryVehicle.vehicle_id;
      const latestBattery = batteryVehicle.telemetry_data && batteryVehicle.telemetry_data[0];
      const flightStatus = data.flightStatus.vehicles.find(v => v.vehicle_id === vehicleId);
      const latestStatus = flightStatus?.status_data?.[0];
      const missions = data.missions.vehicles.find(v => v.vehicle_id === vehicleId)?.missions || [];
      
      if (latestBattery) {
        performance.push({
          vehicle_id: vehicleId,
          name: `Drone ${vehicleId}`,
          hours: (missions.length * 1.5).toFixed(1),
          acres: Math.round(missions.length * 88.67),
          battery: Math.round(latestBattery.remaining || latestBattery.voltage / 10),
          status: latestStatus?.armed ? 'active' : latestBattery.remaining < 20 ? 'charging' : 'maintenance',
        });
      }
    });
    return performance;
  }, []);

  const processPilotActivity = useCallback((data) => {
    const pilots = [];
    const pilotMap = new Map();
    
    data.missions.vehicles.forEach(vehicle => {
      if (vehicle.pilot_id) {
        if (!pilotMap.has(vehicle.pilot_id)) {
          pilotMap.set(vehicle.pilot_id, {
            name: `Pilot ${vehicle.pilot_id}`,
            flights: 0,
            hours: 0,
            acres: 0,
          });
        }
        const pilot = pilotMap.get(vehicle.pilot_id);
        pilot.flights += vehicle.missions ? vehicle.missions.length : 0;
        pilot.hours += (vehicle.missions ? vehicle.missions.length : 0) * 1.5;
        pilot.acres += Math.round((vehicle.missions ? vehicle.missions.length : 0) * 88.67);
      }
    });
    
    pilotMap.forEach((pilot, id) => {
      pilots.push({
        ...pilot,
        hours: pilot.hours.toFixed(1),
        rating: 4.0 + Math.random() * 1.0,
      });
    });
    
    return pilots.sort((a, b) => b.flights - a.flights).slice(0, 5);
  }, []);

  const updateDroneTrails = useCallback((newPositions) => {
    setDroneTrails(prevTrails => {
      const updatedTrails = { ...prevTrails };
      const maxTrailLength = 80;

      newPositions.forEach(drone => {
        if (
          drone.lat == null ||
          drone.lng == null ||
          isNaN(drone.lat) ||
          isNaN(drone.lng) ||
          Math.abs(drone.lat) > 90 ||
          Math.abs(drone.lng) > 180
        ) {
          return;
        }

        const vehicleId = `${drone.vehicle_id}_${drone.mission_id}`;

        const currentPos = {
          lat: Number(drone.lat),
          lng: Number(drone.lng),
          timestamp: Date.now()
        };

        if (!updatedTrails[vehicleId]) {
          updatedTrails[vehicleId] = [currentPos];
        } else {
          const lastPos =
            updatedTrails[vehicleId][
              updatedTrails[vehicleId].length - 1
            ];

          const distance = Math.hypot(
            lastPos.lat - currentPos.lat,
            lastPos.lng - currentPos.lng
          );

          if (distance > 0.00005 && distance < 0.003) {
            updatedTrails[vehicleId] = [
              ...updatedTrails[vehicleId],
              currentPos
            ].slice(
              drone.vehicle_id === selectedDrone?.vehicle_id
                ? -80
                : -10
            );
          }
        }
      });

      const activeDroneIds = new Set(
        newPositions.map(d => `${d.vehicle_id}_${d.mission_id}`)
      );

      Object.keys(updatedTrails).forEach(id => {
        if (!activeDroneIds.has(id)) {
          delete updatedTrails[id];
        }
      });

      return updatedTrails;
    });
  }, [selectedDrone]);

  const handleDroneClick = (drone) => {
    setSelectedDrone(drone);
    setSelectedDroneTelemetry(drone);
  };

  const handleClearSelected = () => {
    setSelectedDrone(null);

    if (livePositions.length > 0) {
      setSelectedDroneTelemetry(livePositions[0]);

      if (mapRef.current) {
        const bounds = new window.google.maps.LatLngBounds();
        livePositions.forEach(drone => {
          bounds.extend({
            lat: Number(drone.lat),
            lng: Number(drone.lng)
          });
        });
        mapRef.current.fitBounds(bounds);
      }
    }
  };

  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
    setMapLoaded(true);
    setTimeout(() => {
      window.google.maps.event.trigger(map, "resize");
    }, 500);
  }, []);

  // ── CHANGED: removed setIsLoading(true) — hook manages loading state ────
  const handleTimeRangeChange = (range) => {
    if (range === timeRange) return;
    if (range === "custom") {
      setTimeRange("custom");
      return;
    }
    setTimeRange(range);
  };
  // ────────────────────────────────────────────────────────────────────────

  const memoizedIcons = useRef({});
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupType, setPopupType] = useState("info");

  // ════════════════════════════════════════════════════════════════════════
  //  CHANGE 1 — Build a stable cache key from all filter values
  //
  //  This is the key the hook uses to decide when to re-fetch.
  //  Every unique combination of filters gets its own sessionStorage slot,
  //  so switching filters instantly shows the last-seen data for that filter
  //  while a fresh fetch runs in the background.
  // ════════════════════════════════════════════════════════════════════════
 const [appliedPilotSearch, setAppliedPilotSearch] = useState("");
const [appliedMinutes, setAppliedMinutes] = useState("");
const [appliedTimeFilterType, setAppliedTimeFilterType] = useState("");

const dashboardCacheKey = [
  "dashboard",
  timeRange,
  timeRange === "custom" ? customDateRange.start_date : "",
  timeRange === "custom" ? customDateRange.end_date : "",
  appliedPilotSearch,
  appliedMinutes,
  appliedTimeFilterType,
  viewAsAdminId ?? "none",
].join("|");

  // ════════════════════════════════════════════════════════════════════════
  //  CHANGE 2 — Replace the big loadAllDashboardData useCallback + the
  //  isFetchingRef / firstLoad refs with a single useDashboardCache() call.
  //
  //  The hook returns:
  //    data         — the response (may be the cached copy on first render)
  //    isLoading    — true ONLY when there is no cache at all (genuine first load)
  //    isRefreshing — true during a silent background refresh
  //    refetch      — call this wherever you previously called loadAllDashboardData
  // ════════════════════════════════════════════════════════════════════════
  const {
    data:         dashboardApiResponse,
    isLoading,
    isRefreshing,
    refetch:      loadAllDashboardData,
  } = useDashboardCache(
    dashboardCacheKey,
    async () => {
      let payload = {};

      if (timeRange === "custom") {
        if (!customDateRange.start_date || !customDateRange.end_date) return null;
        payload = {
          filter_type: "custom",
          start_date:  customDateRange.start_date,
          end_date:    customDateRange.end_date,
        };
      } else {
        const today = new Date().toISOString().split("T")[0];
        payload = {
          filter_type:
            timeRange === "day"   ? "day"   :
            timeRange === "week"  ? "week"  :
            timeRange === "month" ? "month" : "year",
          date: today,
        };
      }

     if (appliedPilotSearch.trim()) {
  payload.pilot_email = appliedPilotSearch.trim();
}

 const parsedMinutes = parseFloat(appliedMinutes);

if (
  appliedMinutes !== "" &&
  appliedTimeFilterType !== "" &&
  !isNaN(parsedMinutes) &&
  parsedMinutes > 0
) {
  payload.time = `${parsedMinutes}min`;
  payload.time_type = appliedTimeFilterType;
}

      const res = await fetchDashboardSummary(payload);

      // Handle session expiry
      if (res?.error === "Unauthorized") {
        setPopupMessage("Session expired, redirecting to login page");
        setPopupType("error");
        setPopupOpen(true);
        setTimeout(() => navigate("/login"), 2000);
        return null;
      }

      return res;
    },
    400 // debounce ms
  );

  // ════════════════════════════════════════════════════════════════════════
  //  CHANGE 3 — Parse the API response into component state.
  //
  //  Previously this logic lived inside loadAllDashboardData itself.
  //  Now it lives in a useEffect that watches dashboardApiResponse.
  //  This fires both when stale cache is shown AND when fresh data arrives,
  //  so the UI is always in sync with whatever data the hook provides.
  // ════════════════════════════════════════════════════════════════════════
  useEffect(() => {
    if (!dashboardApiResponse || dashboardApiResponse.error) return;

    // Notifications
    // const deviceNotifications =
    //   dashboardApiResponse?.notifications?.device_notifications || {};
    // setNotificationsData(deviceNotifications);

    // Pick the right dashboard section
    const dashboardPayload = dashboardApiResponse?.dashboard;
    let dashboardSection =
      dashboardPayload?.admin             ||
      dashboardPayload?.superadmin_company ||
      dashboardPayload?.admin_companies   ||
      dashboardPayload?.view_as_admin     ||
      null;

    if (!dashboardSection) return;

    // Cards
    if (dashboardSection.cards) {
      setStats({
        totalFlights: dashboardSection.cards.total_missions        || 0,
        totalAcres:   dashboardSection.cards.total_acres           || 0,
        activePilots: dashboardSection.cards.active_pilots         || 0,
        flightHours:  dashboardSection.cards.total_mission_hours
                        ? dashboardSection.cards.total_mission_hours.toFixed(1)
                        : "0",
        sprayedAcres: dashboardSection.cards.total_sprayed_acres   || 0,
        activeDrones: dashboardSection.cards.active_drones         || 0,
      });
    }

    // Chart
    if (dashboardSection.chart) {
      const transformed = Object.entries(dashboardSection.chart).map(
        ([key, flights]) => {
          if (timeRange === "week" || timeRange === "year") {
            return {
              day: key,
              flights: flights || 0,
              acres: dashboardSection.cards?.total_sprayed_acres || Math.round((flights || 0) * 88.67)
            };
          }
          const date = new Date(key);
          return {
            day: !isNaN(date.getTime())
              ? date.toLocaleDateString("en-US", { month: "short", day: "2-digit" })
              : key,
            flights: flights || 0,
            acres: dashboardSection.cards?.total_sprayed_acres || Math.round((flights || 0) * 88.67)
          };
        }
      );
      setWeeklyData(transformed);
      setTotalFlightsThisWeek(dashboardSection.cards?.total_missions      || 0);
      setTotalAcresThisWeek(  dashboardSection.cards?.total_sprayed_acres  || 0);
    }

    // Vehicle hours
if (
  Array.isArray(dashboardSection.vehicles) &&
  dashboardSection.vehicles.length > 0
) {
  const vehiclesArray = dashboardSection.vehicles.map((vehicle) => ({
    vehicle_id: vehicle.vehicle_id,
    hours: Number(vehicle.flight_hours || 0),
  }));

  setVehicleHours(
    vehiclesArray.sort((a, b) => b.hours - a.hours)
  );
} else {
  setVehicleHours([]);
}

    // Top pilots
    if (Array.isArray(dashboardSection.top_pilots)) {
      setTopPilots(dashboardSection.top_pilots);
    }

  }, [dashboardApiResponse, timeRange]);
  // ════════════════════════════════════════════════════════════════════════

  // These three functions are kept exactly as they were — they still work
  const fetchDashboard = async () => {
    await loadAllDashboardData();
  };

  const fetchMissions = async () => {
    await loadAllDashboardData();
  };

  // const fetchNotifications = async () => {
  //   await loadAllDashboardData(); 
  // };

  // const loadRecentMissions = async () => {
  //   try {
  //     setIsLoadingMissions(true);
  //     setMissionsError(null);

  //     let filterType = timeRange;
  //     let startDate = null;
  //     let endDate = null;
  //     if (timeRange === "custom") {
  //       startDate = customDateRange.start_date;
  //       endDate = customDateRange.end_date;
  //       if (!startDate || !endDate) {
  //         setRecentFlights([]);
  //         return;
  //       }
  //     }

  //     const missions = await fetchRecentMissions(
  //       5,
  //       filterType,
  //       startDate,
  //       endDate,
  //       pilotSearch,
  //       selectedMinutes,
  //       timeFilterType
  //     );

  //     setRecentFlights(missions || []);

  //   } catch (err) {
  //     console.error("Recent missions error:", err);
  //     setMissionsError("Failed to load recent missions");
  //   } finally {
  //     setIsLoadingMissions(false);
  //   }
  // };

  // ── The old "trigger" useEffect that called loadAllDashboardData is removed.
  //    The hook handles triggering automatically when dashboardCacheKey changes.
const loadRecentMissions = async (
  pilotEmail = appliedPilotSearch,
  minutes = appliedMinutes,
  filterTypeValue = appliedTimeFilterType
) => {
  try {
    setIsLoadingMissions(true);
    setMissionsError(null);

    // ── CHECK MISSIONS CACHE FIRST ──────────────────────
    const missionCacheKey =
      `missionsCache_${timeRange}_${customDateRange.start_date}_${customDateRange.end_date}_${pilotEmail}_${minutes || "none"}_${filterTypeValue || "none"}`;

    const cachedMissions = sessionStorage.getItem(missionCacheKey);

    if (cachedMissions) {
      const { data, ts } = JSON.parse(cachedMissions);

      if (Date.now() - ts < 5 * 60 * 1000) {
        setRecentFlights(data || []);
        setIsLoadingMissions(false);
      }
    }

    // ────────────────────────────────────────────────────

    let filterType = timeRange;
    let startDate = null;
    let endDate = null;

    if (timeRange === "custom") {
      startDate = customDateRange.start_date;
      endDate = customDateRange.end_date;

      if (!startDate || !endDate) {
        setRecentFlights([]);
        return;
      }
    }

    const missions = await fetchRecentMissions(
      5,
      filterType,
      startDate,
      endDate,
      pilotEmail,
      minutes || "",
      filterTypeValue || ""
    );

    // ── SAVE TO CACHE ────────────────────────────────────
    sessionStorage.setItem(
      missionCacheKey,
      JSON.stringify({
        data: missions || [],
        ts: Date.now(),
      })
    );

    // ────────────────────────────────────────────────────

    setRecentFlights(missions || []);

  } catch (err) {
    console.error("Recent missions error:", err);
    setMissionsError("Failed to load recent missions");
  } finally {
    setIsLoadingMissions(false);
  }
};
useEffect(() => {
  loadRecentMissions(
    appliedPilotSearch,
    appliedMinutes,
    appliedTimeFilterType
  );
}, [
  timeRange,
  customDateRange.start_date,
  customDateRange.end_date,
  appliedPilotSearch,
  appliedMinutes,
  appliedTimeFilterType
]);

  useEffect(() => {
    fetch(`${API_BASE_URL}/live-drone-tracking`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "all" })
    })
      .then(res => res.json())
      .then(data => {
        console.log("📡 INITIAL API:", data);
        if (data.drones && data.drones.length > 0) {
          setLivePositions(data.drones);
          updateDroneTrails(data.drones);
        }
      })
      .catch(err => {
        console.error("❌ Initial API error:", err);
      });
  }, []);

  const maxFlights = weeklyData.length > 0 ? Math.max(...weeklyData.map(d => d.flights), 1) : 1;
  const maxAcres = weeklyData.length > 0 ? Math.max(...weeklyData.map(d => d.acres), 100) : 100;

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <span key={i} className={`star ${i < fullStars ? 'filled' : 'empty'}`}>
          {i < fullStars ? '★' : '☆'}
        </span>
      );
    }
    return stars;
  };

  const peakDay = weeklyData.length > 0 
    ? weeklyData.reduce((max, day) => day.flights > max.flights ? day : max, weeklyData[0])
    : { day: 'Mon', flights: 2 };

  const flightHoursChange = totalFlightsThisWeek > 0 ? 
    (parseFloat(stats.flightHours) / totalFlightsThisWeek).toFixed(1) : "0";

  const getTimeRangeLabel = () => {
    switch (timeRange) {
      case "day": return "Total Today";
      case "week": return "Total This Week";
      case "month": return "Total This Month";
      case "year": return "Total This Year";
      default: return "Total";
    }
  };

  const sessionData = JSON.parse(sessionStorage.getItem("session_data"));

useEffect(() => {
  const adminId =
    sessionStorage.getItem("view_as_admin_id") ||
    localStorage.getItem("view_as_admin_id") ||
    null;

  console.log("🔥 VIEW AS ADMIN UPDATED:", adminId);
  setViewAsAdminId(adminId);
}, [location.pathname]);

  console.log("VIEW AS ADMIN:", viewAsAdminId);

  useDashboardWebSocket({
    userId: sessionData?.user_id,
    role: sessionData?.role,
    viewAsAdminId,
    setLivePositions,
    updateDroneTrails,
  });

  const toggleMissionStats = async (missionId, flight) => {
    if (expandedMissionStats === missionId) {
      setExpandedMissionStats(null);
    } else {
      setExpandedMissionStats(missionId);
      setIsPilotStatsLoading(true);
      
      try {
        let payload = {};
        if (timeRange === "custom") {
          if (!customDateRange.start_date || !customDateRange.end_date) {
            setPopupMessage("Please select a date range first");
            setPopupType("error");
            setPopupOpen(true);
            setIsPilotStatsLoading(false);
            return;
          }
          payload = {
            filter_type: "custom",
            start_date: customDateRange.start_date,
            end_date: customDateRange.end_date
          };
        } else {
          const today = new Date().toISOString().split("T")[0];
          payload = {
            filter_type: timeRange,
            date: today
          };
        }
        if (flight.pilot_email) {
          payload.pilot_email = flight.pilot_email;
        }
     const minutes = parseFloat(selectedMinutes);

if (
  selectedMinutes !== "" &&
  timeFilterType !== "" &&
  !isNaN(minutes) &&
  minutes > 0
) {
  payload.time = `${minutes}min`;
  payload.time_type = timeFilterType;
}
        if (flight.start_time) {
          payload.reference_start_time = flight.start_time;
        }
        
        console.log("📤 Sending payload:", payload);
        const missionsList = await fetchRecentMissions(
          5,
          timeRange,
          timeRange === "custom" ? customDateRange.start_date : null,
          timeRange === "custom" ? customDateRange.end_date   : null,
          pilotSearch,
          selectedMinutes,
          timeFilterType
        );
        console.log("📊 Missions list length:", missionsList.length);
        const clickedMission = missionsList.find(m => m.mission_id === missionId);
        const stats = calculatePilotStatsFromMissions(
          clickedMission ? [clickedMission] : []
        );
        console.log("📈 Calculated stats:", stats);
        setPilotTimeStats(prev => ({ ...prev, [missionId]: stats }));
        if (!clickedMission) {
          setPilotTimeStats(prev => ({
            ...prev,
            [missionId]: {
              total_missions: 0,
              total_sprayed_acres: 0,
              total_litres: 0,
              total_flight_minutes: 0,
              vehicles: [],
            }
          }));
        }
      } catch (err) {
        console.error("❌ Error fetching stats:", err);
        setPopupMessage("Failed to fetch pilot statistics");
        setPopupType("error");
        setPopupOpen(true);
        setPilotTimeStats(prev => ({
          ...prev,
          [missionId]: {
            total_missions: 0,
            total_sprayed_acres: 0,
            total_litres: 0,
            total_flight_minutes: 0,
            vehicles: [],
          }
        }));
      } finally {
        setIsPilotStatsLoading(false);
      }
    }
  };

  const closeStatsPopup = () => {
    setPilotStatsPopup(false);
    setStatsPopupAnchor(null);
  };
  // Check if we're on the notifications page
if (location.pathname === "/admin/notifications") {
  return <NotificationsPage role="admin" />;
}

  if (loadError) return <div>Error loading maps</div>;
  if (!isLoaded) return <div>Loading Map...</div>;

  // ── isLoading is now false on refresh if cache exists, so the spinner
  //    only appears on the genuine first-ever load. No other change here.
  if (isLoading) {
    return (
      <div className="dashboard-wrapper">
        <Sidebar />
        <div className="dashboard-content">
          <div className="custom-loading-container">
            <img src={pavamanLogo} alt="Loading" className="spinning-logo" />
            <p className="loading-text">Loading dashboard data...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="dashboard-wrapper">
        <Sidebar />
        <div className="dashboard-content">
          <div className="error-container">
            <div className="error-icon">⚠️</div>
            <h3>Error Loading Dashboard</h3>
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-wrapper">
      <Sidebar />

      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />

      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Dashboard</h1>
            <p className="dashboard-subtitle">Drone Operations Dashboard</p>
          </div>
          
         <div className="header-right">

  {!(
    sessionData?.role?.toLowerCase() === "superadmin" ||
    viewAsAdminId
  ) && (
    <NotificationBell
      notificationsData={notificationsData}
      setNotificationsData={setNotificationsData}
      role="admin"
    />
  )}

  <div className="date-range">
              <span className="current-date">{new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</span>
              <div className="ad-time-buttons">
                {['day','week','month','year','custom'].map(range => (
                  <button
                    key={range}
                    className={`ad-time-btn ${timeRange === range ? 'active' : ''}`}
                    onClick={() => handleTimeRangeChange(range)}
                  >
                    {range.charAt(0).toUpperCase() + range.slice(1)}
                  </button>
                ))}
              </div>

              {timeRange === 'custom' && (
                <div className="custom-date-range">
                  <input 
                    type="date" 
                    className="date-input"
                    value={customDateRange.start_date}
                    onChange={(e) => setCustomDateRange({...customDateRange, start_date: e.target.value})}
                    placeholder="Start Date"
                  />
                  <span className="date-separator">to</span>
                  <input 
                    type="date" 
                    className="date-input"
                    value={customDateRange.end_date}
                    onChange={(e) => setCustomDateRange({...customDateRange, end_date: e.target.value})}
                    placeholder="End Date"
                  />
                  {/* ── CHANGED: removed setIsLoading(true) and manual loadAllDashboardData()
                      call — the hook auto-triggers when customDateRange changes ── */}
                  <button 
                    className="apply-date-btn"
                    onClick={() => {
                      if (customDateRange.start_date && customDateRange.end_date) {
                        loadAllDashboardData();
                      }
                    }}
                  >
                    Apply
                  </button>
                </div>
              )}
            </div>
            {/* ── CHANGED: shows "Updating…" during silent background refresh ── */}
            <div className="live-indicator">
              <span className="live-dot"></span>
              {isRefreshing ? "Updating…" : "Live Data"}
            </div>
          </div>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
              <img src={require("../images/drone image.png")} alt="Drone" className="drone-icon" />
            </div>
            <div className="stat-content">
              <p className="stat-label">Total Missions</p>
              <h3 className="stat-value">{stats.totalFlights}</h3>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)' }}>
              <span className="icon">🌾</span>
            </div>
            <div className="stat-content">
              <p className="stat-label">Total Acres</p>
              <h3 className="stat-value">{stats.totalAcres.toLocaleString()}</h3>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)' }}>
              <span className="icon">🌾</span>
            </div>
            <div className="stat-content">
              <p className="stat-label">Sprayed Acres</p>
              <h3 className="stat-value">{stats.sprayedAcres.toLocaleString()}</h3>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)' }}>
              <span className="icon">👨‍✈️</span>
            </div>
            <div className="stat-content">
              <p className="stat-label">Active Pilots</p>
              <h3 className="stat-value">{stats.activePilots}</h3>
            </div>
          </div>

          <div className="stat-card">
            <div className="stat-icon" style={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }}>
              <span className="icon">⏱️</span>
            </div>
            <div className="stat-content">
              <p className="stat-label">Missions Hours</p>
              <h3 className="stat-value">{stats.flightHours}</h3>
            </div>
          </div>
        </div>

        <div className="charts-grid">
          <div className="chart-card main-chart">
            <div className="chart-header">
              <div className="chart-header-row">
                <h3>Missions Overview</h3>
                <button className="view-more-btn" onClick={() => navigate("/admin/flights")}>View More</button>
              </div>
            </div>

            <div className="weekly-line-chart">
              {isWeeklyDataLoading ? (
                <div className="custom-loading-container" style={{ minHeight: "300px" }}>
                  <img src={pavamanLogo} alt="Loading" className="spinning-logo" />
                  <p className="loading-text">Loading flight data...</p>
                </div>
              ) : weeklyData && weeklyData.length > 0 ? (
                <div className="chart-wrapper">
                  <svg className="flight-chart" viewBox="0 0 800 400" preserveAspectRatio="xMidYMid meet">
                    <defs>
                      <linearGradient id="areaGradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#4CAF50" stopOpacity="0.8" />
                        <stop offset="100%" stopColor="#4CAF50" stopOpacity="0.1" />
                      </linearGradient>
                    </defs>

                    {(() => {
                      const chartWidth = 800;
                      const chartPadding = { top: 30, right: 30, bottom: 80, left: 60 };
                      const innerWidth = chartWidth - chartPadding.left - chartPadding.right;
                      const innerHeight = 400 - chartPadding.top - chartPadding.bottom;
                      const flightValues = weeklyData.map(d => d.flights || 0);
                      const maxFlights = Math.max(...flightValues, 1);
                      let niceMax;
                      if (maxFlights === 0) {
                        niceMax = 1;
                      } else if (maxFlights <= 5) {
                        niceMax = 5;
                      } else if (maxFlights <= 10) {
                        niceMax = 10;
                      } else if (maxFlights <= 50) {
                        niceMax = Math.ceil(maxFlights / 5) * 5;
                      } else {
                        niceMax = Math.ceil(maxFlights / 10) * 10;
                      }
                      const steps = 5;
                      const stepValue = niceMax / steps;
                      const yAxisValues = Array.from({ length: steps + 1 }, (_, i) => Math.round(i * stepValue));
                      const points = weeklyData.map((day, index) => {
                        const x = chartPadding.left + (weeklyData.length === 1 ? innerWidth / 2 : (index / (weeklyData.length - 1)) * innerWidth);
                        const y = chartPadding.top + innerHeight - ((day.flights || 0) / niceMax) * innerHeight;
                        return { x, y, value: day.flights, label: day.day };
                      });
                      
                      let linePath = "";
                      let areaPath = "";
                      
                      if (points.length > 0) {
                        linePath = `M ${points[0].x} ${points[0].y}`;
                        for (let i = 1; i < points.length; i++) {
                          const prev = points[i - 1];
                          const curr = points[i];
                          const cp1x = prev.x + (curr.x - prev.x) / 3;
                          const cp1y = prev.y;
                          const cp2x = prev.x + (curr.x - prev.x) * 2 / 3;
                          const cp2y = curr.y;
                          linePath += ` C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${curr.x} ${curr.y}`;
                        }
                        areaPath = linePath + ` L ${points[points.length - 1].x} ${chartPadding.top + innerHeight}` + ` L ${chartPadding.left} ${chartPadding.top + innerHeight} Z`;
                      }
                      
                      return (
                        <>
                          {yAxisValues.map((value) => {
                            const y = chartPadding.top + innerHeight - (value / niceMax) * innerHeight;
                            return (
                              <g key={value}>
                                <line x1={chartPadding.left} y1={y} x2={chartWidth - chartPadding.right} y2={y} stroke="#e0e0e0" strokeWidth="1" strokeDasharray="5,5" />
                              </g>
                            );
                          })}
                          
                          {yAxisValues.slice().reverse().map((value) => {
                            const y = chartPadding.top + innerHeight - (value / niceMax) * innerHeight;
                            return (
                              <text key={value} x={chartPadding.left - 10} y={y} textAnchor="end" dominantBaseline="middle" className="axis-labels" fill="#666" fontSize="12">
                                {Math.round(value)}
                              </text>
                            );
                          })}
                          
                          {points.length > 0 && maxFlights > 0 && <path d={areaPath} fill="url(#areaGradient)" opacity="0.3" />}
                          {points.length > 0 && maxFlights > 0 && <path d={linePath} fill="none" stroke="#4CAF50" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />}
                          
                          {points.map((point, index) => (
                            <g key={`point-${index}`} className="chart-point-group">
                              <circle cx={point.x} cy={point.y} r="10" fill="transparent" />
                              <circle cx={point.x} cy={point.y} r="3" fill="#4CAF50" stroke="white" strokeWidth="1.5" className="data-point" />
                              <g className="custom-tooltip">
                                <rect x={point.x - 38} y={point.y - 45} width="76" height="28" rx="6" fill="#1f2937" />
                                <text x={point.x} y={point.y - 27} textAnchor="middle" fill="#fff" fontSize="11" fontWeight="600">
                                  {point.value} Flights
                                </text>
                              </g>
                              <text x={point.x} y={point.y - 12} textAnchor="middle" className="point-value" fill="#333" fontSize="10" fontWeight="600">
                                {point.value === 0 ? "" : point.value}
                              </text>
                            </g>
                          ))}

                          {points.map((point, index) => (
                            <text
                              key={`xlabel-${index}`} 
                              x={point.x}
                              y={chartPadding.top + innerHeight + 15} 
                              textAnchor="middle" 
                              transform={`rotate(45, ${point.x}, ${chartPadding.top + innerHeight + 25})`}
                              className="x-axis-labels"
                            >
                              {point.label}
                            </text>
                          ))}

                          <line x1={chartPadding.left} y1={chartPadding.top + innerHeight} x2={chartWidth - chartPadding.right} y2={chartPadding.top + innerHeight} stroke="#333" strokeWidth="1.2" />
                          <line x1={chartPadding.left} y1={chartPadding.top} x2={chartPadding.left} y2={chartPadding.top + innerHeight} stroke="#333" strokeWidth="1.2" />
                        </>
                      );
                    })()}
                  </svg>
                </div>
              ) : (
                <div className="no-data-message" style={{ minHeight: "300px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                  No flight data available
                </div>
              )}
            </div>
            
            <div className="line-chart-footer">
              {(() => {
                if (!weeklyData || weeklyData.length === 0) return null;
                const peakDay = weeklyData.reduce((max, day) => (day.flights || 0) > (max.flights || 0) ? day : max, weeklyData[0]);
                return (
                  <>
                    <div className="insight-item">
                      <span className="insight-label">{timeRange === "year" ? "Peak Month:" : "Peak Day:"}</span>
                      <span className="insight-value">{peakDay.day} ({peakDay.flights || 0} missions)</span>
                    </div>
                    <div className="insight-item">
                      <span className="insight-label">{getTimeRangeLabel()}:</span>
                      <span className="insight-value">{totalFlightsThisWeek} missions, {totalAcresThisWeek.toLocaleString()} sprayed acres</span>
                    </div>
                  </>
                );
              })()}
            </div>
          </div>
        </div>

        <div className="performance-grid">
          <div className="performance-card">
            <div className="card-header">
              <h3>Drone Performance</h3>
            </div>
            {isVehicleHoursLoading ? (
              <div className="loading-small">Loading...</div>
            ) : vehicleHours.length === 0 ? (
              <div className="no-data">No performance data</div>
            ) : (
              <div className="drone-performance-bars">
                {(() => {
                  const maxHours = Math.max(
  ...vehicleHours.map(v => v.hours),
  1
);

return vehicleHours.map((drone, index) => {
  const width = (drone.hours / maxHours) * 100;

  return (
    <div key={index} className="performance-row">
      <div className="performance-label">
        {drone.vehicle_id}
      </div>

      <div className="performance-bar-wrapper">
        <div
          className="performance-bar"
          style={{ width: `${width}%` }}
        />
      </div>

      <div className="performance-hours">
        {drone.hours} Hours
      </div>
    </div>
  );
});
                })()}
              </div>
            )}
          </div>

          <div className="performance-card">
            <div className="card-header">
              <h3>Top 5 Pilots by Flight Hours</h3>
            </div>
            {isTopPilotsLoading ? (
              <div className="loading-small">Loading pilots...</div>
            ) : topPilots.length === 0 ? (
              <div className="no-data">No pilot data available</div>
            ) : (
              <div className="pilots-list">
                {topPilots.map((pilot, index) => (
                  <div key={pilot.pilot_id || index} className="pilot-row">
                    <div className="pilot-rank"><span className="rank-number">{index + 1}</span></div>
                    <div className="pilot-info"><div className="pilot-name">{pilot.pilot_name || `Pilot ${pilot.pilot_id}`}</div></div>
                    <div className="pilot-hours">
                      <div className="hours-value">{pilot.total_hours?.toFixed(2) || '0.00'}</div>
                      <div className="hours-label">Hours</div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="table-card">
          <div className="card-header">
            <h3>Recent Missions</h3>
            <div className="table-controls">

              <div className="pilot-search-wrapper">
                <input
                  type="text"
                  placeholder="Search Pilot Email..."
                  className="pilot-search-input"
                  value={pilotSearch}
                  onChange={(e) => {
                    setPilotSearch(e.target.value);
                    pilotSearchRef.current = e.target.value;
                  }}
                />
               {pilotSearch && (
  <button
    className="clear-search-btn"
    onClick={async () => {
      // clear input
      setPilotSearch("");
      pilotSearchRef.current = "";

      // clear applied filters
      setAppliedPilotSearch("");
      setAppliedMinutes("");
      setAppliedTimeFilterType("");

      // clear UI values
      setSelectedMinutes("");
      setTimeFilterType("");

      // reload unfiltered missions
      await loadRecentMissions("", "", "");
    }}
  >
    ✕
  </button>
)}
              </div>

              <div className="pilot-time-filter">
                <div className="clock-icon">⏰</div>
                <select
                  className="pilot-filter-select"
                  value={timeFilterType}
                  onChange={(e) => {
                    setTimeFilterType(e.target.value);
                    timeFilterTypeRef.current = e.target.value;
                  }}
                > <option value="">Select Comparison</option>
                  <option value="lt">Shorter than (less than)</option>
                  <option value="gt">Longer than (greater than)</option>
                  <option value="eq">Approx Equal to</option>
                </select>
                <input
  type="text"
  inputMode="decimal"
  value={selectedMinutes}
  onChange={(e) => {
    const value = e.target.value;

    // allow only numbers and decimal
    if (/^\d*\.?\d*$/.test(value)) {
      setSelectedMinutes(value);
      selectedMinutesRef.current = value;
    }
  }}
  className="minute-input"
  placeholder="Minutes"
/>
                <span className="minute-label">Minutes</span>
                {/* ── CHANGED: removed isFetchingRef.current = false and setIsLoading(true) ── */}
<button
  className="apply-filter-btn"
  onClick={async () => {
    setExpandedMissionStats(null);

    setAppliedPilotSearch(pilotSearch);
    setAppliedMinutes(selectedMinutes);
    setAppliedTimeFilterType(timeFilterType);

    await loadRecentMissions(
      pilotSearch,
      selectedMinutes,
      timeFilterType
    );
  }}
>
  Apply Filters
</button>

<button
  className="reset-filters-btn"
  onClick={async () => {
    setExpandedMissionStats(null);

    // Clear UI values
    setPilotSearch("");
    setSelectedMinutes("");
    setTimeFilterType("");

    // Clear refs
    pilotSearchRef.current = "";
    selectedMinutesRef.current = "";
    timeFilterTypeRef.current = "";

    // Clear applied values
    setAppliedPilotSearch("");
    setAppliedMinutes("");
    setAppliedTimeFilterType("");

    // Reload initial data
    await loadRecentMissions("", "", "");
  }}
>
  Clear Filters
</button>

              </div>

              <button
  className="view-more-btn"
onClick={() => {
  console.log("Sending Filters", {
    appliedPilotSearch,
    appliedMinutes,
    appliedTimeFilterType,
  });

  navigate("/admin/all-flights", {
    state: {
      filters: {
        currentPage: 1,
        searchTerm: appliedPilotSearch,
        selectedMinutes: appliedMinutes,
        timeFilterType: appliedTimeFilterType,
        startDate: "",
        endDate: "",
        filterStatus: "all",
        // showFilters: true,
      },
    },
  });
}}
  
>
  View All Missions →
</button>
            </div>
          </div>

          {isLoadingMissions ? (
            <div className="loading-small"><div className="loading-spinner small"></div>Loading recent missions...</div>
          ) : missionsError ? (
            <div className="error-message small"><span>⚠️</span><span>{missionsError}</span></div>
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Mission ID</th>
                    <th>Vehicle ID</th>
                    <th>Pilot Email</th>
                    <th>Plot Name</th>
                    <th>Flight Mode</th>
                    <th>Status</th>
                    <th>Start Time</th>
                    <th>End Time</th>
                    <th>Replay</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {recentFlights.map((flight, index) => (
                    <React.Fragment key={flight.mission_id}>
                      <tr>
                        <td>{index + 1}</td>
                        <td>
                          <div className="project-info">
                            <div className="project-name">{flight.mission_id || "N/A"}</div>
                          </div>
                        </td>
                        <td>
                          <div className="drone-tag">{flight.vehicle_id || "N/A"}</div>
                        </td>
                        <td>{flight.pilot_email || "N/A"}</td>
                        <td>{flight.plot_name || "N/A"}</td>
                        <td>{flight.flight_mode || "N/A"}</td>
                        <td>
                          <span className={`status-badge ${flight.status?.toLowerCase()}`}>
                            {flight.status}
                          </span>
                        </td>
                        <td>{flight.start_time ? formatDateTime(flight.start_time) : "N/A"}</td>
                        <td>{flight.end_time ? formatDateTime(flight.end_time) : "N/A"}</td>
                        <td>
                          <button className="replay-btn" onClick={() => handleReplayMission(flight)} title="Replay Mission">
                            <FiPlayCircle size={20} />
                          </button>
                        </td>
                        <td>
                          <button 
                            className="pv-expand-btn-modern"
                            onClick={() => toggleMissionStats(flight.mission_id, flight)}
                            title="View Statistics"
                          >
                            {expandedMissionStats === flight.mission_id ? <FiChevronUp size={18} /> : <FiChevronDown size={18} />}
                          </button>
                        </td>
                      </tr>
{expandedMissionStats === flight.mission_id && (
  <tr className="mission-expanded-row">
    <td colSpan="11" className="mission-expanded-cell">
      <div className="mission-stats-container">

        <div className="stats-cards-row">

          <div className="stat-card-mini">
            <div className="stat-icon-mini sprayed-icon">🌾</div>
            <div className="stat-info">
              <span className="stat-label-mini">Sprayed Acres</span>
              <span className="stat-value-mini">
                {pilotTimeStats[flight.mission_id]?.total_sprayed_acres || 0}
              </span>
            </div>
          </div>

          <div className="stat-card-mini">
            <div className="stat-icon-mini litres-icon">💧</div>
            <div className="stat-info">
              <span className="stat-label-mini">Litres Consumed</span>
              <span className="stat-value-mini">
                {pilotTimeStats[flight.mission_id]?.total_litres || 0}
              </span>
            </div>
          </div>

          <div className="stat-card-mini">
            <div className="stat-icon-mini time-icon">⏱️</div>
            <div className="stat-info">
              <span className="stat-label-mini">Flying Minutes</span>
              <span className="stat-value-mini">
                {pilotTimeStats[flight.mission_id]?.total_flight_minutes || 0}
              </span>
            </div>
          </div>

          {/* UIN CARD */}
        <div className="stat-card-mini">
  <div className="stat-icon-mini uin-icon">🚁</div>

  <div className="stat-info">
    <span className="stat-label-mini">UIN Number</span>

    <span className="uin-card-value">
      {flight.vehicle_uin || "N/A"}
    </span>
  </div>
</div>

        </div>

      </div>
    </td>
  </tr>
)}
                    </React.Fragment>
                  ))}
                  {recentFlights.length === 0 && (
                    <tr>
                      <td colSpan="11" className="no-data">No recent flights found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <div className="dash-live-activity">
          <div className="dash-activity-header">
            <h3>Live Flight Activity</h3>
            <div className="dash-live-stats">
              <div className="dash-stat-item">
                <span className="dash-stat-value">{livePositions.length}</span>
                <span className="dash-stat-label">Live Stream</span>
              </div>
              {selectedDrone && (<button className="dash-reset-btn" onClick={handleClearSelected}>Reset View</button>)}
            </div>
          </div>

          <div className="dash-live-container">
            <div className={`dash-map-section ${selectedDrone ? 'dash-with-telemetry' : ''}`}>
              <GoogleMap mapContainerStyle={mapContainerStyle} center={defaultCenter} zoom={5} options={mapOptions} onLoad={onMapLoad}>
                {mapLoaded && (
                  <>
                    <DroneTrails droneTrails={droneTrails} selectedDrone={selectedDrone} droneColors={droneColors} />
                    {livePositions.length > 0 && !selectedDrone && mapRef.current && (
                      <FitBounds positions={livePositions} selectedDrone={selectedDrone} droneTrails={droneTrails} map={mapRef.current} />
                    )}
                    {selectedDrone && mapRef.current && (
                      <FlyToDrone
                        drone={selectedDrone}
                        map={mapRef.current}
                        droneTrails={droneTrails}
                        selectedDroneTelemetry={selectedDroneTelemetry}
                      />
                    )}
                    <MarkerClusterer
                      options={{
                        imagePath: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m",
                        gridSize: 25,
                        minimumClusterSize: 3,
                        maxZoom: 18,
                        zoomOnClick: true,
                        averageCenter: true
                      }}
                    >
                      {(clusterer) =>
                        livePositions.map((drone, index) => {
                          const color = droneColors[index % droneColors.length];
                          return (
                            <DroneMarker
                              key={`${drone.vehicle_id}-${drone.mission_id}`}
                              drone={drone}
                              clusterer={clusterer}
                              icon={
                                memoizedIcons.current[
                                  `${color}_${drone.heading}_${selectedDrone?.vehicle_id === drone.vehicle_id}`
                                ] ||
                                (
                                  memoizedIcons.current[
                                    `${color}_${drone.heading}_${selectedDrone?.vehicle_id === drone.vehicle_id}`
                                  ] = createDroneIcon(
                                    color,
                                    selectedDrone?.vehicle_id === drone.vehicle_id &&
                                    selectedDrone?.mission_id === drone.mission_id,
                                    drone.heading || 0
                                  )
                                )
                              }
                              onClick={() => handleDroneClick(drone)}
                              isSelected={
                                selectedDrone?.vehicle_id === drone.vehicle_id &&
                                selectedDrone?.mission_id === drone.mission_id
                              }
                            />
                          );
                        })
                      }
                    </MarkerClusterer>
                  </>
                )}
              </GoogleMap>
            </div>
            {selectedDroneTelemetry && (<TelemetryDisplay drone={selectedDroneTelemetry} />)}
          </div>
        </div>
      </div>
    </div>
  );
}; 

export default Dashboard;
